const state = {
    // 使用对象存储多个数据源的缓存
    cachedData: {},
    cacheExpireTime: 3600000 // 缓存过期时间，默认1小时（毫秒）
};

const mutations = {
    // 设置特定数据源的缓存数据
    SET_CACHED_DATA(state, { key, data }) {
        state.cachedData[key] = {
            data: data,
            timestamp: Date.now() // 记录当前时间戳
        };
    },
    // 清除特定数据源的缓存
    CLEAR_CACHED_DATA(state, key) {
        if (key) {
            delete state.cachedData[key];
        } else {
            // 如果没有指定key，则清除所有缓存
            state.cachedData = {};
        }
    },
    // 清除所有过期缓存
    CLEAR_EXPIRED_CACHE(state) {
        const now = Date.now();
        for (const key in state.cachedData) {
            if (state.cachedData[key].timestamp && 
                (now - state.cachedData[key].timestamp) > state.cacheExpireTime) {
                delete state.cachedData[key];
            }
        }
    }
};

const actions = {
    // 异步获取并缓存数据（支持多数据源）
    async fetchAndCacheData({ commit, state }, { url, key }) {
        const cacheKey = key || url;
        
        // 检查缓存是否有效
        if (state.cachedData[cacheKey] && 
            (Date.now() - state.cachedData[cacheKey].timestamp) <= state.cacheExpireTime) {
            return state.cachedData[cacheKey].data;
        }
        
        const { commmonAjax } = require('@/api/common');
        try {
            const params = {
                url,
                method: 'get'
            };
            const result = await commmonAjax(params);
            if (result.resultCode === '200') {
                const data = result.resultData?.list || [];
                commit('SET_CACHED_DATA', { key: cacheKey, data });
                return data;
            }
            return [];
        } catch (error) {
            console.error('获取数据失败:', error);
            return [];
        }
    },
    // 清除特定缓存
    clearCache({ commit }, key) {
        commit('CLEAR_CACHED_DATA', key);
    },
    // 清除所有过期缓存
    checkAndClearExpiredCache({ commit }) {
        commit('CLEAR_EXPIRED_CACHE');
    }
};

const getters = {
    // 获取特定数据源的缓存数据
    getCachedData: (state) => (key) => {
        return state.cachedData[key] ? state.cachedData[key].data : [];
    },
    // 获取特定数据源的缓存时间戳
    getCacheTimestamp: (state) => (key) => {
        return state.cachedData[key] ? state.cachedData[key].timestamp : null;
    },
    // 检查特定数据源的缓存是否有效
    isCacheValid: (state) => (key) => {
        if (!state.cachedData[key] || !state.cachedData[key].timestamp) return false;
        return (Date.now() - state.cachedData[key].timestamp) <= state.cacheExpireTime;
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
};